import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { EventsApiService } from '../api/events.service';

@Injectable({ providedIn: 'root' })
export class EventDetailsResolver implements Resolve<any> {
  constructor(
    private apiService: EventsApiService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const eventId = route.paramMap.get('id');
    if (eventId) {
      return this.apiService.getEventDetails(eventId);
    }
    return of(null);
  }
}